import { render, staticRenderFns } from "./addAreaCompoment.vue?vue&type=template&id=b1b34936&scoped=true&"
import script from "./addAreaCompoment.vue?vue&type=script&lang=js&"
export * from "./addAreaCompoment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1b34936",
  null
  
)

export default component.exports